import styled from 'styled-components';
import {Typography, Select, Divider, DatePicker, SelectProps, Form} from 'antd';
import {FormItem} from '../../../../ui-kit/Input';
import {Button} from '../../../../ui-kit/Button';
import {Media} from '../../../../ui-kit/theme/breakpoints';
const {Text} = Typography;

export const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  padding: 64px 141px 32px 141px;
  ${Media.down.xxl} {
    padding: 54px 90px 32px 90px;
  }
  ${Media.down.m} {
    padding: 16px;
  }
`;

export const LoadingWrapper = styled.div`
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
`;

export const CodeForm = styled(Form)`
  padding: 18px 27px 21px 27px;
  box-sizing: border-box;
  border: 1px solid ${({theme}) => theme.palette.background.darkGray};
  border-radius: 8px;
  background-color: ${({theme}) => theme.palette.background.white};
`;

export const ModalDescr = styled(Text)`
  font-size: 14px;
  line-height: 22px;
  display: block;
`;

export const TitleLine = styled.div`
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const GroupTitle = styled(Text)`
  font-weight: ${({theme}) => theme.font.weight.bold};
  font-size: 20px;
  line-height: 28px;
  display: block;
  margin-bottom: 22px;
  margin-left: 22px;
`;
export const CreateNewMessageCodeForm = styled(CodeForm)`
  padding-left: 0;
  padding-right: 0;
`;

export const TicketTypeTip = styled.span`
  display: block;
  width: 100%;
  text-align: end;
  font-size: 10px;
  cursor: pointer;
  text-decoration: underline;
  margin-top: -4px;
`;

export const CodeFormItem = styled(FormItem)<{$noMargin?: boolean}>`
  width: 100%;
  && {
    margin-bottom: ${({$noMargin}) => ($noMargin ? '10px' : '22px')};
  }
  .ant-form-item-explain-error {
    color: ${({theme}) => theme.palette.common.redBrown};
    font-size: 10px;
    margin-top: 8px;
  }
  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input {
    border: 2px solid ${({theme}) => theme.palette.common.redBrown};
  }
  .ant-form-item-required {
    width: 100%;
  }
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    display: none;
  }
  .ant-col.ant-form-item-label {
    padding-bottom: 4px;
  }
  .ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(
      .ant-input-affix-wrapper-borderless
    ).ant-input-affix-wrapper {
    border: 2px solid ${({theme}) => theme.palette.common.redBrown};
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    min-height: 38px;
  }
  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    padding-top: 3px;
  }
`;

export const StyledSpan = styled.span`
  font-size: 12px;
`;

export const TextLimitTip = styled(StyledSpan)<{len: number; max: number}>`
  display: inline-block;
  width: 100%;
  text-align: end;
  ${({len, max}) => len > max && 'color: red'};
`;

export const FormButton = styled(Button)`
  width: 222px;
  height: 43px;
  font-size: 16px;
  font-weight: ${({theme}) => theme.font.weight.mediumBold};
`;

export const StyledSelect = styled(Select)<SelectProps>`
  &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${({theme}) => theme.palette.common.brown};
  }
  &.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: ${({theme}) => theme.palette.common.brown};
    box-shadow: none;
  }
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 5px;
  }
  .ant-select-arrow {
    color: ${({theme}) => theme.palette.common.darkGray};
  }
`;

export const WithHint = styled.div`
  position: relative;
`;

export const SelectButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SelectOptionsButton = styled(Button)`
  margin-right: 16px;
  margin-bottom: 4px;
`;

export const MessageFormWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  &.ant-picker {
    width: 100% !important;
  }
`;

export const DoubleSelectWrapper = styled(MessageFormWrapper)`
  gap: 25px;
`;

export const CustomCheckboxWrapper = styled.div`
  margin-bottom: 16px;
`;

export const LeftSide = styled.div`
  padding-left: 27px;
  width: calc(50% - 24px);
`;

export const RightSide = styled.div`
  padding-right: 27px;
  width: calc(50% - 24px);
`;

export const SettingsTitle = styled(Text)`
  font-weight: ${({theme}) => theme.font.weight.bold};
  font-size: 16px;
  line-height: 24px;
  display: block;
  margin-bottom: 8px;
`;

export const StyledSmallSelect = styled(StyledSelect)`
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    width: 208px;
  }
`;

export const StyledCalendarDivider = styled(Divider)`
  margin-top: 0px;
  margin-bottom: 10px;
`;

export const CalendarFooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 24px;
  padding-bottom: 5px;
`;

export const ErrorLine = styled.div`
  padding: 10px 0px;
  color: ${({theme}) => theme.palette.common.red};
`;

export const ErrorText = styled(Text)`
  font-size: 14px;
  color: ${({theme}) => theme.palette.common.red};
`;

export const SuccessLine = styled.div`
  padding: 10px 0px;
  text-align: center;
`;

export const SuccessText = styled(Text)`
  font-size: 14px;
  color: ${({theme}) => theme.palette.common.darkGreen};
`;

export const WeatherClosureInfo = styled.div`
  background-color: #d9d9d9;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
`;

export const WeatherClosureTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
  color: #495258;
`;

export const WeatherClosureLocation = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #495258;
`;

export const CustomDatePicker = styled(DatePicker)`
  &.ant-picker {
    width: 100%;
    height: 38px;
    border-radius: 5px;
  }
  &.ant-picker:hover,
  &.ant-picker-focused {
    border-color: ${({theme}) => theme.palette.common.brown};
    box-shadow: none;
  }
  &.ant-picker-today-btn {
    color: ${({theme}) => theme.palette.common.brown};
  }
`;
